
import { all } from 'redux-saga/effects';
import { watchAuthSagas } from './sagas/authSaga';
import { fileUploadSaga } from './sagas/fileUploadSaga';
import { dashboardSaga } from './sagas/dashboardSaga';
import { uploadedFilesSaga } from './sagas/uploadedFilesSaga';
import { productSaga } from './sagas/productSaga';
import { competitorsSaga } from './sagas/competitorsSaga';
import { exportSaga } from './sagas/exportSaga';

export function* rootSaga() {
  yield all([
    watchAuthSagas(),
    fileUploadSaga(),
    dashboardSaga(),
    uploadedFilesSaga(),
    productSaga(),
    competitorsSaga(),
    exportSaga(),
  ]);
}
